import { giphyBlack } from '@giphy/colors'
import styled from 'styled-components'
import { MAX_PREVIEW_WIDTH } from './constants'

export const Container = styled.div`
    align-items: flex-start;
    display: flex;
    justify-content: center;
    width: 100%;
`

export const Content = styled.div`
    background: ${giphyBlack};
    border-radius: 6px;
`

export const Panel = styled.div`
    margin: 0 14px;
    width: ${MAX_PREVIEW_WIDTH}px;
`
